import React, { Component } from "react";
import axios from "axios";
import ProductItem from "./ProductItem";
import ProductPage from "./ProductPage";
import HomePage from "./HomePage";
import firebaseApp from "./firebase/firebase";
import Header from './header/Header'
import Footer from './footer/footer'
import HeaderForSingle from "./header/HeaderForSingle";
let allData = [];
let allCategoryData = [];
let ascending = false;

export default class LandingPage extends Component {
    state = {
        productData: [],
        inputValue: '',
        pageType: 'HomePage',
        singleProductData: [],
        showBack: false,
        categoryValue: '',
        headerType: 'default',
    };
    componentDidMount() {
        // this.getProductData();
        this.get_data_from_database();
    }

    showProduct = (productDetail) => {
        this.setState({ singleProductData: productDetail })
        this.setState({ pageType: 'singleProductPage', showBack: true })
    };

    getProductData = () => {
        axios.get("data/data.json").then((res) => {
            allCategoryData = res.data.data
            this.setState({ productData: res.data.data }, () => {
            });


        });
    };

    get_data_from_database = () => {
        let productDataArray = []
        const db = firebaseApp.firestore();
        db.collection("Products").where("projectOwner", "==", 'Amit').get().then(
            (querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    productDataArray.push(doc.data())
                });
            }).catch(err => {
                console.error(err)
            });
        allCategoryData = productDataArray
        this.setState({ productData: productDataArray })
    }

    showRolex = () => {
        let rolexWatch = [];
        for (let i = 0; i < this.state.productData.length; i++) {
            if (this.state.productData[i].productCompany === "Rolex") {
                rolexWatch.push(this.state.productData[i])
            }
        }
        this.setState({ productData: rolexWatch })

    }

    handleInput = (e) => {
        this.setState({ inputValue: e.target.value })
    }

    showAll = () => {
        this.setState({ productData: allData })
    }

    showResult = (e) => {
        if (e.keyCode === 13) {
            let searchArray = []
            for (let i = 0; i < this.state.productData; i++) {
                let keywordData = this.state.productData[i]
                for (let j = 0; j < keywordData.keywords; j++) {
                    if (e.target.value === keywordData.keywords[j])
                        searchArray.push(keywordData)
                }
            }
        }
    }

    getProductCategory = (value) => {
        this.setState({ productData: allCategoryData, categoryValue: value })
        setTimeout(() => {
            let categoryArray = [];
            for (let i = 0; i < this.state.productData.length; i++) {
                if (this.state.productData[i].category === value) {
                    categoryArray.push(this.state.productData[i])
                }
            }
            allData = categoryArray
            this.setState({ productData: categoryArray, pageType: 'productHomePage', headerType: 'singleHeader', showBack: true })

        }, 1);


    }

    handleWatchDropDown = () => {
        this.setState({ productData: allData })
        setTimeout(() => {
            let selectedProductCompany = document.getElementById('watches').value;
            let selectedProductArray = [];
            for (let i = 0; i < this.state.productData.length; i++) {
                if (this.state.productData[i].productCompany === selectedProductCompany) {
                    selectedProductArray.push(this.state.productData[i])
                }
            }
            if (selectedProductCompany === 'All') {
                selectedProductArray = this.state.productData
            }
            this.setState({ productData: selectedProductArray })
        }, 1);


    }

    goBack = () => {
        if (this.state.pageType === 'singleProductPage') {
            this.setState({ pageType: 'productHomePage', headerType: 'singleHeader', showBack: true })
        }
        else if (this.state.pageType === 'productHomePage') {
            this.setState({ pageType: 'HomePage', showBack: false })
        }
    }

    sortByPrice = () => {
        let objs = this.state.productData;
        if (ascending) {
            document.getElementById('priceSort').innerHTML = 'Low to high'
            objs.sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0))
            ascending = !ascending
        } else {
            document.getElementById('priceSort').innerHTML = 'High to low'
            objs.sort((a, b) => (a.price < b.price) ? 1 : ((b.price < a.price) ? -1 : 0))
            ascending = !ascending
        }

        this.setState({ productData: objs })
    }

    render() {
        return (
            <React.Fragment>
                {this.state.headerType === 'default' &&
                    <Header />}
                {/* {this.state.SingleHeader === 'singleHeader' &&
                    <HeaderForSingle />} */}

                {/* {this.state.showBack &&
                    <button onClick={this.goBack} >Back</button>} */}
                {this.state.pageType === 'HomePage' &&
                    <React.Fragment>
                        <div className="commn-title-div text-center foot-title  top-padding">
                            <h1>Category</h1>
                        </div>
                        <HomePage />
                    </React.Fragment>}

                {this.state.pageType === 'productHomePage' &&
                    <div className='container-fluid p-0'>
                        <HeaderForSingle />
                        <div className="row top-space">
                            <div className="container-fluid p-0">
                                <div className="col-12 p-0">
                                    <div className="sticky-header ">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <select name="" id="watches" onChange={this.handleWatchDropDown} className="form-control custom-select-box">
                                                <option value="All">All</option>
                                                <option value="Rolex">Rolex</option>
                                                <option value="Rado">Rado</option>
                                                <option value="China">China</option>
                                            </select>
                                            <button className="btn high-low">Low to High</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <select id="watches" onChange={this.handleWatchDropDown}>
                                <option value="All">All</option>
                                <option value="Rolex">Rolex</option>
                                <option value="Rado">Rado</option>
                                <option value="China">China</option>
                            </select> */}
                        {/* <button id='priceSort' onClick={this.sortByPrice}>Low to high</button> */}
                        {/* <h1>{this.state.categoryValue}</h1> */}
                        <div className="row top-space">
                            <div className="container-fluid p-0">
                                <div className="row align-items-center justify-content-center">


                                    {this.state.productData.map(
                                        (projectItem, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <ProductItem
                                                        data={projectItem}
                                                        showProduct={this.showProduct}
                                                    />
                                                </React.Fragment>
                                            );

                                        },
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>}
                {this.state.pageType === 'singleProductPage' &&
                    < ProductPage data={this.state.singleProductData} />}
                <Footer />
            </React.Fragment>)
    }
}
